//@flow
import React from 'react';
import {IconButton, makeStyles, TextField, Typography} from '@material-ui/core';
import {Add, DeleteOutline} from '@material-ui/icons';

import CustomModal from '../../../elements/CustomModal/CustomModal';
import {colors} from '../../../assets/styles/colors';
import CustomButton from '../../../elements/CustomButton/CustomButton';

type Props = {
  open: boolean,
  onClose: () => void,
};

const useStyles = makeStyles(theme => ({
  modal: {
    maxWidth: '500px',
    margin: '0 auto',
  },
  modalTitle: {
    color: colors.grey800,
    fontWeight: 600,
    display: 'block',
    textAlign: 'center',
    fontSize: '22px',
    marginBottom: '16px',
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    alignItems: 'flex-start',
  },
  taxItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    height: '40px',
    width: '100%',
  },
  input: {
    height: '40px',
    padding: '0 4px',
    textAlign: 'end',
  },
  taxLabel: {
    backgroundColor: '#E4D6FF',
    color: colors.purple,
    fontWeight: 600,
    fontSize: '12px',
    minWidth: '60px',
    height: '100%',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  deleteBtn: {
    color: colors.error,
    padding: '0',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  addBtn: {
    color: colors.grey500,
    background: colors.grey200,
    width: 'calc(100% - 32px)',
    height: '24px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  saveBtn: {
    width: '100%',
    marginTop: '16px',
  },
}));

export default function TaxModal(props: Props) {
  const {open, onClose} = props;

  const classes = useStyles();

  return (
    <CustomModal
      open={open}
      handleCloseModal={onClose}
      className={classes.modal}
    >
      <Typography className={classes.modalTitle}>Tasa de impuestos</Typography>
      <div className={classes.content}>
        <div className={classes.taxItem}>
          <span className={classes.taxLabel}>IGV</span>

          <TextField
            size="small"
            variant="outlined"
            name="discountAmount"
            placeholder="10"
            fullWidth
            inputProps={{className: classes.input}}
            /*           error={!!errors.discountAmount}
          inputRef={register({
            required: 'Campo obligatorio',
            max: {
              value: maxDiscount,
              message: maxDiscountError,
            },
          })} */
            type="number"
          />
          <IconButton className={classes.deleteBtn}>
            <DeleteOutline />
          </IconButton>
        </div>
        <IconButton className={classes.addBtn}>
          <Add />
        </IconButton>
      </div>
      <CustomButton
        variant="contained"
        color="primary"
        className={classes.saveBtn}
      >
        Guardar Cambios
      </CustomButton>
    </CustomModal>
  );
}
